export const HERO_IMG_URL =
  'https://sherpas-prod.s3.eu-west-3.amazonaws.com/landing/landingTvTrichez.webp';
